import { createContext } from 'react';
import type { User, Organization, Membership, AuthResponse } from '../types';
import type { RegisterBody } from '../api/endpoints';

export interface AuthContextValue {
  user: User | null;
  org: Organization | null;
  membership: Membership | null;
  isAuthenticated: boolean;
  isEkomAdmin: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  // SSO (SC-2621): store the token pair from the redirect fragment, hydrate the
  // session via /me, then route by role. Mirrors `login` but without a password.
  completeSsoLogin: (accessToken: string, refreshToken: string) => Promise<void>;
  // Invite accept (SC-2791): the accept POST already returns a full AuthResponse
  // (like login), so this just hydrates + routes from it — no /me hop. The page
  // owns the POST and its error handling; this commits the resulting session.
  completeInviteAccept: (data: AuthResponse) => void;
  register: (body: RegisterBody) => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
